import React, { useEffect, useState } from "react";
import clone from "lodash.clonedeep"
import locale from "locale";
import { Event } from "../../../Comet";
import * as MembersApi from "../../../../../api/cp/members";
import * as EpisodeMembersApi from "../../../../../api/cp/episodeMembers";
import { updateEpisode } from "../../../../../api/cp";
import ParticipantUpdateModal from "../EditModals/ParticipantUpdateModal";
import ParticipantsList from "../components/ParticipantList/ParticipantList";
import ParticipantGroup from '../components/ParticipantGroup';
import {
    Checkbox,
    Col,
    Dropdown,
    MenuItem,
    FormGroup,
    Glyphicon,
    Row,
} from "react-bootstrap";

import './styles.scss';

const GROUPS_LIMIT = 2;

const EpisodeMembers = ({eventKey, episode}) => {
    const [hiddenMembersPhotosInUnexpanded, setHiddenMembersPhotosInUnexpanded] = useState(
        episode.hiddenMembersPhotosInUnexpanded || false
    );
    const [displayMembersVerticalInExpanded, setDisplayMembersVerticalInExpanded] = useState(
        episode.displayMembersVerticalInExpanded || false
    );
    const [showTopics, setSpeakersTopic] = useState(episode.showTopics || true);
    const [isModalVisible, setModalVisible] = useState(false);

    const [roles, setRoles] = useState([]);
    const [groups, setGroups] = useState(null);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [members, setMembers] = useState(null);
    const [editableMember, setEditableMember] = useState(null);

    useEffect(() => {
        getRoles();
        getGroups();
        getMembers();
    }, []);

    function handleEditMember(member, group) {
        setSelectedGroup(group);
        setEditableMember(member);
        setModalVisible(true);
    }

    async function handleUpdateEpisode(value) {
        try {
            await updateEpisode(episode.id, value);
        } catch (error) {
            console.error(error);
        }
    }

    async function getRoles() {
        try {
            const response = await MembersApi.getEventRoles(eventKey);
            setRoles(response);
        } catch (error) {
            console.error(error);
        }
    }

    async function getMembers() {
        try {
            const response = await MembersApi.getEventMembers(eventKey);
            setMembers(response);
        } catch (error) {
            console.error(error);
        }
    }

    async function getGroups() {
        const groups = await EpisodeMembersApi.episodeGroupsList(episode.id);

        if (!!groups?.length) {
            setGroups(groups);
        }
    }

    async function handleCreateGroup(roleId) {
        try {
            const response = await EpisodeMembersApi.episodeCreateGroup(episode.id, {role: roleId});
            setGroups(response);
        } catch (error) {
            console.error(error);
        }
    }

    async function handleUpdateGroup(groupData) {
        try {
            const response = await EpisodeMembersApi.episodeUpdateGroup(groupData.id, groupData);
            setGroups(response);
        } catch (error) {
            console.error(error);
        }
    }

    async function handleRemoveGroup(groupId) {
        try {
            const response = await EpisodeMembersApi.episodeDeleteGroup(groupId);
            setGroups(response);
        } catch (error) {
            console.error(error);
        }
    }

    function addGroupMember(group) {
        setSelectedGroup(group);
        setModalVisible(true);
    }

    async function handleAddGroupMember(member) {
        try {
            const payload = {
                member: member.id,
                ...member,
                group: selectedGroup.id,
            };

            await EpisodeMembersApi.episodeGroupMemberAdd(episode.id, payload);
            getGroups();
            setSelectedGroup(null);
            setEditableMember(null);
        } catch (error) {
            console.error(error);
        }
    }

    async function handleEditGroupMember(updatedMember) {
        try {
            await EpisodeMembersApi.episodeGroupMemberUpdate(updatedMember.id, updatedMember);
            getGroups();
            setSelectedGroup(null);
            setEditableMember(null);
        } catch (error) {
            console.error(error);
        }
    }

    async function handleDeleteGroupMember(memberId) {
        try {
            await EpisodeMembersApi.episodeGroupMemberDelete(memberId);
            getGroups();
            setSelectedGroup(null);
            setEditableMember(null);
        } catch (error) {
            console.error(error);
        }
    }

    async function handleUpdateMembersOrder(payload) {
        try {
            await EpisodeMembersApi.episodeGroupMembersOrder(episode.id, payload);
            getGroups();
            setSelectedGroup(null);
            setEditableMember(null);
        } catch (error) {
            console.error(error);
        }
    }

    async function handleUpdateGroupsOrder(payload) {
        try {
            await EpisodeMembersApi.episodeGroupsOrder(episode.id, payload);
            getGroups();
            setSelectedGroup(null);
            setEditableMember(null);
        } catch (error) {
            console.error(error);
        }
    }

    function handleCometEpisodeUpdate(episode) {
        setHiddenMembersPhotosInUnexpanded(episode.hiddenMembersPhotosInUnexpanded);
        setDisplayMembersVerticalInExpanded(episode.displayMembersVerticalInExpanded);
        setSpeakersTopic(episode.showTopics);
    };

    function handleCloseMembersModal() {
        setModalVisible(false);
        setSelectedGroup(null);
        setEditableMember(null);
    }

    function onMoveGroup(group, index) {
        if (index >= 0 && index < groups?.length) {
            const updatedGroups = clone(groups);
            const groupIndex = groups.findIndex((g) => g.id === group.id);
            updatedGroups.splice(groupIndex, 1);
            updatedGroups.splice(index, 0, group);
            handleUpdateGroupsOrder({sortOrder: updatedGroups.map(({id}) => id)})
        }
    }

    return (
        <section style={{marginTop: '12px'}}>
            <Event event="update:episode" handler={handleCometEpisodeUpdate} />
            <Row>
                <Col xs={12}>
                    <FormGroup>
                        <Checkbox
                            checked={hiddenMembersPhotosInUnexpanded}
                            name="hiddenMembersPhotosInUnexpanded"
                            onChange={(e) => {
                                setHiddenMembersPhotosInUnexpanded(e.target.checked)
                                handleUpdateEpisode({hiddenMembersPhotosInUnexpanded: e.target.checked})
                            }}
                        >
                            Скрывать фотографии спикеров и модераторов из неразвёрнутых плиток
                        </Checkbox>
                    </FormGroup>
                    <FormGroup>
                        <Checkbox
                            checked={displayMembersVerticalInExpanded}
                            name="displayMembersVerticalInExpanded"
                            onChange={(e) => {
                                setDisplayMembersVerticalInExpanded(e.target.checked)
                                handleUpdateEpisode({displayMembersVerticalInExpanded: e.target.checked})
                            }}
                        >
                            Отображать спикеров в развёрнутой плитке списком вертикально
                        </Checkbox>
                    </FormGroup>
                    <hr />
                </Col>
                <Col xs={12}>
                    {
                        !!groups?.length &&
                        groups.map((group, index) => (
                            <ParticipantGroup
                                key={group.id}
                                group={group}
                                onGroupUpdate={handleUpdateGroup}
                                onGroupRemove={handleRemoveGroup}
                                onMove={(index) => onMoveGroup(group, index)}
                                isShowMoveUp={index !== 0}
                                isShowMoveDown={index !== groups?.length - 1}
                                index={index}
                            >
                                <ParticipantsList
                                    group={group}
                                    onAddMember={() => addGroupMember(group)}
                                    onEditMember={handleEditMember}
                                    onUpdateOrder={(episodeMembers) => handleUpdateMembersOrder({sortOrder: episodeMembers.map(({id}) => id), group: group.id})}
                                    onDelete={handleDeleteGroupMember}
                                />
                            </ParticipantGroup>
                        ))
                    }
                </Col>
                <Col xs={12}>
                    <Dropdown
                        id="add-participant-block"
                        // disabled={groups?.length >= GROUPS_LIMIT}
                        onSelect={handleCreateGroup}
                    >
                        <Dropdown.Toggle noCaret>
                            <Glyphicon glyph="plus" />&nbsp;
                            Добавить блок с участниками
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {
                                roles?.map((role) => (
                                    <MenuItem
                                        key={role.id}
                                        eventKey={role.id}
                                    >
                                        {locale.field(role, 'title')}
                                    </MenuItem>
                                ))
                            }
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>
            </Row>

            <ParticipantUpdateModal
                isModalVisible={isModalVisible}
                editableMember={editableMember}
                members={members?.filter(({roles}) => roles.some(({id}) => id === selectedGroup?.role?.id ?? null)) ?? []}
                onAddMember={handleAddGroupMember}
                onEditMember={handleEditGroupMember}
                onClose={handleCloseMembersModal}
            />
        </section>
    );
};

export default EpisodeMembers;
